/**
 * Clip-length formats of a project or library (`format`). Mirrors the backend's
 * `CLIP_FORMATS`; the worker's `CLIP_DURATION_MODES` sets each length:
 * `max_30_sec` 15–30 s, `max_1_min` 30–70 s, `auto` 40–180 s.
 */
export const CLIP_FORMATS = ['max_30_sec', 'max_1_min', 'auto'] as const;

export type ClipFormat = (typeof CLIP_FORMATS)[number];

export const DEFAULT_CLIP_FORMAT: ClipFormat = 'max_1_min';

/** i18n key of each format's label in the upload, duplicate and copy dialogs. */
export const CLIP_FORMAT_LABEL_KEYS: Record<ClipFormat, string> = {
  max_30_sec: 'uploadModal.shortMax30Sec',
  max_1_min: 'uploadModal.shortMax1Min',
  auto: 'uploadModal.automatic',
};
